import React, {Fragment} from "react";
import logo from "./img/logomin.svg";
import {Col, Row} from "react-bootstrap";
import {getMessage} from "./util";

const version = require('../package.json');


const Footer = (props) => {

    return (
        <Fragment>
            <Row className="justify-content-center EvColorBlue pb-4 pt-4 mt-1">
                <Col xs={8} md={6} className={"text-white font-weight-bold"}>
                    <Row className={"m-1"}>
                        <Col >
                            <small>
                                <a target="_blank" href="https://evoting.typeform.com/to/VKwDaENo" className="text-nowrap link-light">Formulario de asistencia: click aquí</a>
                            </small>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col className="text-end">
                    <small style={{fontSize: "small"}}>© {new Date().getFullYear()}, v. {version.version}</small>
                </Col>
            </Row>
        </Fragment>
    );
}


export default Footer;